import React from 'react';
import { Button, Heading, Layout, Text } from '../../../../components/core';
import { getStylesheet } from '../../../../styles';
import { INTERSTITIAL_CONTENT } from '../constants/interstitialContent';
import { SurveyInterstitialRoute } from '../surveyRoutes';

type InterstitialContentProps = {
  interstitialRoute: SurveyInterstitialRoute;
  onContinue: () => void;
};

export const SurveyInterstitialContent = ({
  interstitialRoute,
  onContinue,
}: InterstitialContentProps): JSX.Element => {
  const content = INTERSTITIAL_CONTENT[interstitialRoute];

  return (
    <Layout.VStack space={6} {...styles.container}>
      <Heading.h2>{content.heading}</Heading.h2>

      {content.additionalInfo !== null && <Text.para>{content.additionalInfo}</Text.para>}

      <Button.primaryLarge
        testID={content.interstitialContinueButtonTestId}
        onPress={onContinue}
        aria-label="Continue to the related questionnaire"
      >
        Continue
      </Button.primaryLarge>
    </Layout.VStack>
  );
};
const styles = getStylesheet({
  container: {
    justifyContent: 'center',
    height: '100%',
  },
});
